import React, { useState } from "react";

const PreviewQR = ({ form }) => {
  const [zoom, setZoom] = useState(1); // default zoom 100%
  const qrList = form?.id || [];
  const totalBoxes = qrList.length;

  const paperWidth = Number(form.paperWidth || 0);
  const paperHeight = Number(form.paperHeight || 0);
  const marginTop = Number(form.marginTop || 0);
  const marginBottom = Number(form.marginBottom || 0);
  const marginLeft = Number(form.marginLeft || 0);
  const marginRight = Number(form.marginRight || 0);
  const boxWidth = Number(form.boxWidth || 0);
  const boxHeight = Number(form.boxHeight || 0);
  const gapX = Number(form.gapX || 0);
  const gapY = Number(form.gapY || 0);
  const qrSize = Number(form.qrSize || 0);
  const fontSize = Number(form.fontSize || 3);
  const showBox = form?.showBox;
  const logoSize = Number(form.logoSize || 16);
  const gapQrLogo = Number(form.gapQrLogo || 5);
  const paddingX = Number(form.paddingX || 5);
  const paddingY = Number(form.paddingY || 5);

  const qrMarginTop = Number(form.qrMarginTop || 0);
  const qrMarginBottom = Number(form.qrMarginBottom || 0);
  const qrMarginLeft = Number(form.qrMarginLeft || 0);
  const logoMarginTop = Number(form.logoMarginTop || 0);
  const logoMarginBottom = Number(form.logoMarginBottom || 0);

  const availableWidth = paperWidth - marginLeft - marginRight;
  const availableHeight = paperHeight - marginTop - marginBottom;

  const cols = Math.floor((availableWidth + gapX) / (boxWidth + gapX));
  const rows = Math.floor((availableHeight + gapY) / (boxHeight + gapY));
  const perPage = cols * rows;

  if (totalBoxes === 0 || cols <= 0 || rows <= 0 || perPage <= 0) {
    return <div style={{ color: "#999" }}>Silakan lengkapi isian form</div>;
  }

  // Bagi QR ke halaman
  const pages = [];
  for (let i = 0; i < totalBoxes; i++) {
    const pageIndex = Math.floor(i / perPage);
    const indexInPage = i % perPage;
    const row = Math.floor(indexInPage / cols);
    const col = indexInPage % cols;
    const x = col * (boxWidth + gapX);
    const y = row * (boxHeight + gapY);
    if (!pages[pageIndex]) pages[pageIndex] = [];
    pages[pageIndex].push({ x, y, index: i + 1, id: qrList[i] });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
      {/* Tombol Zoom */}
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          borderWidth: 1,
          borderColor: "#ccc",
          padding: 10,
          borderRadius: 8,
          backgroundColor: "#f8f9fa",
        }}
      >
        <button
          onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))}
          style={{
            padding: "6px 12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            background: "#f8f9fa",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          ➖
        </button>
        <span
          style={{
            fontWeight: "bold",
            minWidth: 50,
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {Math.round(zoom * 100)}%
        </span>
        <button
          onClick={() => setZoom((z) => Math.min(3, z + 0.1))}
          style={{
            padding: "6px 12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            background: "#f8f9fa",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          ➕
        </button>
      </div>

      {/* Halaman Preview */}
      <div
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: "top center",
          transition: "transform 0.2s ease-in-out",
        }}
      >
        {pages.map((boxes, pageIndex) => (
          <div
            key={pageIndex}
            style={{
              width: `${paperWidth}px`,
              height: `${paperHeight}px`,
              border: "0.5px solid #ccc",
              background: "#fff",
              position: "relative",
              margin: `${form.pageGap || 3}px auto`,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: marginTop,
                left: marginLeft,
                width: availableWidth,
                height: availableHeight,
              }}
            >
              {boxes.map((box, idx) => {
                const hasLogo = Boolean(form.logoUrl);

                return (
                  <div
                    key={idx}
                    style={{
                      position: "absolute",
                      top: box.y,
                      left: box.x,
                      width: boxWidth,
                      height: boxHeight,
                      border: showBox ? "1px solid #000" : "none",
                      boxSizing: "border-box",
                      fontSize: `${fontSize}px`,
                      display: "flex",
                      flexDirection: hasLogo ? "row" : "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: `${paddingY}px ${paddingX}px`,
                    }}
                  >
                    {/* Kolom Label + QR */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginLeft: `${qrMarginLeft}px`,
                      }}
                    >
                      <div
                        style={{
                          marginBottom: `${form.labelGapY || 0}px`,
                          fontSize: `${fontSize}px`,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          marginTop: `${qrMarginTop}px`,
                          fontWeight: "bold",
                        }}
                      >
                        {`Label ${box.index}`}
                      </div>

                      <div
                        style={{
                          marginBottom: `${qrMarginBottom}px`,
                          width: qrSize,
                          height: qrSize,
                          backgroundColor: "#000",
                        }}
                      />
                    </div>

                    {/* Logo */}
                    {hasLogo && (
                      <img
                        src={form.logoUrl}
                        alt="logo"
                        style={{
                          width: logoSize,
                          height: logoSize,
                          objectFit: "contain",
                          marginLeft: `${gapQrLogo}px`,
                          marginTop: `${logoMarginTop}px`,
                          marginBottom: `${logoMarginBottom}px`,
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreviewQR;
// import React from "react";

// // const PreviewQR = ({ form }) => {
// //   const qrList = form?.id || [];
// //   const totalBoxes = qrList.length;

// //   const paperWidth = Number(form.paperWidth || 0);
// //   const paperHeight = Number(form.paperHeight || 0);
// //   const marginTop = Number(form.marginTop || 0);
// //   const marginBottom = Number(form.marginBottom || 0);
// //   const marginLeft = Number(form.marginLeft || 0);
// //   const marginRight = Number(form.marginRight || 0);
// //   const boxWidth = Number(form.boxWidth || 0);
// //   const boxHeight = Number(form.boxHeight || 0);
// //   const gapX = Number(form.gapX || 0);
// //   const gapY = Number(form.gapY || 0);
// //   const qrSize = Number(form.qrSize || 0);
// //   const fontSize = Number(form.fontSize || 8);
// //   const showBox = form?.showBox;

// //   const availableWidth = paperWidth - marginLeft - marginRight;
// //   const availableHeight = paperHeight - marginTop - marginBottom;

// //   const cols = Math.floor((availableWidth + gapX) / (boxWidth + gapX));
// //   const rows = Math.floor((availableHeight + gapY) / (boxHeight + gapY));
// //   const perPage = cols * rows;

// //   // Validasi minimum input
// //   if (totalBoxes === 0 || cols <= 0 || rows <= 0 || perPage <= 0) {
// //     return (
// //       <div style={{ color: "#999" }}>
// //         Silakan lengkapi isian form dengan benar
// //       </div>
// //     );
// //   }

// //   const pages = [];
// //   for (let i = 0; i < totalBoxes; i++) {
// //     const pageIndex = Math.floor(i / perPage);
// //     const indexInPage = i % perPage;
// //     const row = Math.floor(indexInPage / cols);
// //     const col = indexInPage % cols;

// //     const x = col * (boxWidth + gapX);
// //     const y = row * (boxHeight + gapY);

// //     if (!pages[pageIndex]) pages[pageIndex] = [];

// //     pages[pageIndex].push({ x, y, index: i + 1, id: qrList[i] });
// //   }

// //   return (
// //     <div
// //       style={{
// //         display: "flex",
// //         flexDirection: "column",
// //         gap: 10,
// //       }}
// //     >
// //       {pages.map((boxes, pageIndex) => (
// //         <div
// //           key={pageIndex}
// //           style={{
// //             width: `${paperWidth}px`,
// //             height: `${paperHeight}px`,
// //             border: "1px solid #000",
// //             background: "#fff",
// //             position: "relative",
// //             margin: "auto",
// //           }}
// //         >
// //           {/* Work Area */}
// //           <div
// //             style={{
// //               position: "absolute",
// //               top: marginTop,
// //               left: marginLeft,
// //               width: availableWidth,
// //               height: availableHeight,
// //             }}
// //           >
// //             {boxes.map((box, idx) => {
// //               const qrX = (boxWidth - qrSize) / 2;
// //               const qrY = (boxHeight - qrSize) / 2;
// //               const textY = qrY + qrSize;
// //               return (
// //                 <div
// //                   key={idx}
// //                   style={{
// //                     position: "absolute",
// //                     top: box.y,
// //                     left: box.x,
// //                     width: boxWidth,
// //                     height: boxHeight,
// //                     border: showBox ? "1px solid #000" : "none",
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     fontSize: `${fontSize}px`,
// //                     textAlign: "center",
// //                   }}
// //                 >
// //                   <div
// //                     style={{
// //                       position: "absolute",
// //                       top: qrY,
// //                       left: qrX,
// //                       width: qrSize,
// //                       height: qrSize,
// //                       backgroundColor: "#000",
// //                     }}
// //                   />
// //                   <div
// //                     style={{
// //                       position: "absolute",
// //                       top: textY,
// //                       //   left: box.x,
// //                       width: boxWidth,
// //                       textAlign: "center",
// //                       fontSize: `${fontSize - 5}px`,
// //                       lineHeight: 1,
// //                       whiteSpace: "nowrap",
// //                       overflow: "hidden",
// //                       textOverflow: "ellipsis",
// //                     }}
// //                   >
// //                     text
// //                   </div>
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // };

// // versi2
// // const PreviewQR = ({ form }) => {
// //   const qrList = form?.id || [];
// //   const totalBoxes = qrList.length;

// //   const paperWidth = Number(form.paperWidth || 0);
// //   const paperHeight = Number(form.paperHeight || 0);
// //   const marginTop = Number(form.marginTop || 0);
// //   const marginBottom = Number(form.marginBottom || 0);
// //   const marginLeft = Number(form.marginLeft || 0);
// //   const marginRight = Number(form.marginRight || 0);
// //   const boxWidth = Number(form.boxWidth || 0);
// //   const boxHeight = Number(form.boxHeight || 0);
// //   const gapX = Number(form.gapX || 0);
// //   const gapY = Number(form.gapY || 0);
// //   const qrSize = Number(form.qrSize || 0);
// //   const fontSize = Number(form.fontSize || 8);
// //   const showBox = form?.showBox;
// //   const logoSize = Number(form.logoSize || 30);
// //   const gapQrLogo = Number(form.gapQrLogo || 5);
// //   const paddingX = Number(form.paddingX || 5);
// //   const paddingY = Number(form.paddingY || 5);

// //   const availableWidth = paperWidth - marginLeft - marginRight;
// //   const availableHeight = paperHeight - marginTop - marginBottom;

// //   const cols = Math.floor((availableWidth + gapX) / (boxWidth + gapX));
// //   const rows = Math.floor((availableHeight + gapY) / (boxHeight + gapY));
// //   const perPage = cols * rows;

// //   // Validasi minimum input
// //   if (totalBoxes === 0 || cols <= 0 || rows <= 0 || perPage <= 0) {
// //     return (
// //       <div style={{ color: "#999" }}>
// //         Silakan lengkapi isian form dengan benar
// //       </div>
// //     );
// //   }

// //   // Bagi QR ke halaman
// //   const pages = [];
// //   for (let i = 0; i < totalBoxes; i++) {
// //     const pageIndex = Math.floor(i / perPage);
// //     const indexInPage = i % perPage;
// //     const row = Math.floor(indexInPage / cols);
// //     const col = indexInPage % cols;
// //     const x = col * (boxWidth + gapX);
// //     const y = row * (boxHeight + gapY);
// //     if (!pages[pageIndex]) pages[pageIndex] = [];
// //     pages[pageIndex].push({ x, y, index: i + 1, id: qrList[i] });
// //   }

// //   return (
// //     <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// //       {pages.map((boxes, pageIndex) => (
// //         <div
// //           key={pageIndex}
// //           style={{
// //             width: `${paperWidth}px`,
// //             height: `${paperHeight}px`,
// //             border: "1px solid #000",
// //             background: "#fff",
// //             position: "relative",
// //             margin: "auto",
// //           }}
// //         >
// //           {/* Work Area */}
// //           <div
// //             style={{
// //               position: "absolute",
// //               top: marginTop,
// //               left: marginLeft,
// //               width: availableWidth,
// //               height: availableHeight,
// //             }}
// //           >
// //             {/* {boxes.map((box, idx) => {
// //               const labelHeight = fontSize + 4; // label height
// //               const qrY = paddingY + labelHeight;
// //               const qrX = paddingX;
// //               const logoX = qrX + qrSize + gapQrLogo;
// //               const logoY = qrY;

// //               // cek overflow
// //               const totalWidthNeeded =
// //                 qrSize + gapQrLogo + logoSize + paddingX * 2;
// //               const totalHeightNeeded =
// //                 labelHeight + Math.max(qrSize, logoSize) + paddingY * 2;
// //               const overflow =
// //                 totalWidthNeeded > boxWidth || totalHeightNeeded > boxHeight;

// //               return (
// //                 <div
// //                   key={idx}
// //                   style={{
// //                     position: "absolute",
// //                     top: box.y,
// //                     left: box.x,
// //                     width: boxWidth,
// //                     height: boxHeight,
// //                     border: showBox ? "1px solid #000" : "none",
// //                     boxSizing: "border-box",
// //                     padding: `${paddingY}px ${paddingX}px`,
// //                     fontSize: `${fontSize}px`,
// //                   }}
// //                 >

// //                   <div
// //                     style={{
// //                       position: "absolute",
// //                       top: paddingY, // jarak dari atas box
// //                       left: qrX, // mulai dari posisi QR
// //                       width: qrSize, // selebar QR
// //                       textAlign: "center",
// //                       fontSize: `${fontSize}px`,
// //                       whiteSpace: "nowrap",
// //                       overflow: "hidden",
// //                       textOverflow: "ellipsis",
// //                     }}
// //                   >
// //                     {overflow
// //                       ? "Ukuran box tidak cukup!"
// //                       : `Label ${box.index}`}
// //                   </div>

// //                   <div
// //                     style={{
// //                       position: "absolute",
// //                       top: qrY,
// //                       left: qrX,
// //                       width: qrSize,
// //                       height: qrSize,
// //                       backgroundColor: "#000",
// //                     }}
// //                   />

// //                   {form.logoUrl ? (
// //                     <img
// //                       src={form.logoUrl}
// //                       alt="logo"
// //                       style={{
// //                         position: "absolute",
// //                         top: logoY,
// //                         left: logoX,
// //                         width: logoSize,
// //                         height: logoSize,
// //                         objectFit: "contain",
// //                       }}
// //                     />
// //                   ) : (
// //                     <div
// //                       style={{
// //                         position: "absolute",
// //                         top: logoY,
// //                         left: logoX,
// //                         width: logoSize,
// //                         height: logoSize,
// //                         backgroundColor: "#f00",
// //                       }}
// //                     />
// //                   )}
// //                 </div>
// //               );
// //             })} */}
// //             {boxes.map((box, idx) => {
// //               const hasLogo = Boolean(form.logoUrl);

// //               return (
// //                 <div
// //                   key={idx}
// //                   style={{
// //                     position: "absolute",
// //                     top: box.y,
// //                     left: box.x,
// //                     width: boxWidth,
// //                     height: boxHeight,
// //                     border: showBox ? "1px solid #000" : "none",
// //                     boxSizing: "border-box",
// //                     fontSize: `${fontSize}px`,
// //                     display: "flex",
// //                     flexDirection: hasLogo ? "row" : "column",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     padding: `${paddingY}px ${paddingX}px`,
// //                   }}
// //                 >
// //                   <div
// //                     style={{
// //                       display: "flex",
// //                       flexDirection: "column",
// //                       alignItems: "center",
// //                     }}
// //                   >
// //                     <div
// //                       style={{
// //                         marginBottom: `${form.labelGapY || 0}px`, // jarak label ke QR selalu pakai input
// //                         fontSize: `${fontSize}px`,
// //                         whiteSpace: "nowrap",
// //                         overflow: "hidden",
// //                         textOverflow: "ellipsis",
// //                         textAlign: "center",
// //                       }}
// //                     >
// //                       {`Label ${box.index}`}
// //                     </div>

// //                     <div
// //                       style={{
// //                         width: qrSize,
// //                         height: qrSize,
// //                         backgroundColor: "#000",
// //                       }}
// //                     />
// //                   </div>

// //                   {hasLogo && (
// //                     <img
// //                       src={form.logoUrl}
// //                       alt="logo"
// //                       style={{
// //                         width: logoSize,
// //                         height: logoSize,
// //                         objectFit: "contain",
// //                         marginLeft: `${gapQrLogo}px`,
// //                       }}
// //                     />
// //                   )}
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       ))}
// //     </div>
// //   );
// // };

// const PreviewQR = ({ form }) => {
//   const qrList = form?.id || [];
//   const totalBoxes = qrList.length;

//   const paperWidth = Number(form.paperWidth || 0);
//   const paperHeight = Number(form.paperHeight || 0);
//   const marginTop = Number(form.marginTop || 0);
//   const marginBottom = Number(form.marginBottom || 0);
//   const marginLeft = Number(form.marginLeft || 0);
//   const marginRight = Number(form.marginRight || 0);
//   const boxWidth = Number(form.boxWidth || 0);
//   const boxHeight = Number(form.boxHeight || 0);
//   const gapX = Number(form.gapX || 0);
//   const gapY = Number(form.gapY || 0);
//   const qrSize = Number(form.qrSize || 0);
//   const fontSize = Number(form.fontSize || 8);
//   const showBox = form?.showBox;
//   const logoSize = Number(form.logoSize || 30);
//   const gapQrLogo = Number(form.gapQrLogo || 5);
//   const paddingX = Number(form.paddingX || 5);
//   const paddingY = Number(form.paddingY || 5);

//   // tambahan margin khusus QR & Logo
//   const qrMarginTop = Number(form.qrMarginTop || 0);
//   const qrMarginBottom = Number(form.qrMarginBottom || 0);
//   const qrMarginLeft = Number(form.qrMarginLeft || 0);
//   const logoMarginTop = Number(form.logoMarginTop || 0);
//   const logoMarginBottom = Number(form.logoMarginBottom || 0);

//   const availableWidth = paperWidth - marginLeft - marginRight;
//   const availableHeight = paperHeight - marginTop - marginBottom;

//   const cols = Math.floor((availableWidth + gapX) / (boxWidth + gapX));
//   const rows = Math.floor((availableHeight + gapY) / (boxHeight + gapY));
//   const perPage = cols * rows;

//   if (totalBoxes === 0 || cols <= 0 || rows <= 0 || perPage <= 0) {
//     return <div style={{ color: "#999" }}>Silakan lengkapi isian form</div>;
//   }

//   // Bagi QR ke halaman
//   const pages = [];
//   for (let i = 0; i < totalBoxes; i++) {
//     const pageIndex = Math.floor(i / perPage);
//     const indexInPage = i % perPage;
//     const row = Math.floor(indexInPage / cols);
//     const col = indexInPage % cols;
//     const x = col * (boxWidth + gapX);
//     const y = row * (boxHeight + gapY);
//     if (!pages[pageIndex]) pages[pageIndex] = [];
//     pages[pageIndex].push({ x, y, index: i + 1, id: qrList[i] });
//   }

//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//       {pages.map((boxes, pageIndex) => (
//         <div
//           key={pageIndex}
//           style={{
//             width: `${paperWidth}px`,
//             height: `${paperHeight}px`,
//             border: "1px solid #000",
//             background: "#fff",
//             position: "relative",
//             margin: "auto",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               top: marginTop,
//               left: marginLeft,
//               width: availableWidth,
//               height: availableHeight,
//             }}
//           >
//             {boxes.map((box, idx) => {
//               const hasLogo = Boolean(form.logoUrl);

//               return (
//                 <div
//                   key={idx}
//                   style={{
//                     position: "absolute",
//                     top: box.y,
//                     left: box.x,
//                     width: boxWidth,
//                     height: boxHeight,
//                     border: showBox ? "1px solid #000" : "none",
//                     boxSizing: "border-box",
//                     fontSize: `${fontSize}px`,
//                     display: "flex",
//                     flexDirection: hasLogo ? "row" : "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     padding: `${paddingY}px ${paddingX}px`,
//                   }}
//                 >
//                   {/* Kolom Label + QR */}
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginLeft: `${qrMarginLeft}px`,
//                     }}
//                   >
//                     {/* Label */}
//                     <div
//                       style={{
//                         marginBottom: `${form.labelGapY || 0}px`,
//                         fontSize: `${fontSize}px`,
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         textAlign: "center",
//                         marginTop: `${qrMarginTop}px`,
//                       }}
//                     >
//                       {`Label ${box.index}`}
//                     </div>

//                     {/* QR */}
//                     <div
//                       style={{
//                         // marginTop: `${qrMarginTop}px`,
//                         marginBottom: `${qrMarginBottom}px`,
//                         width: qrSize,
//                         height: qrSize,
//                         backgroundColor: "#000",
//                       }}
//                     />
//                   </div>

//                   {/* Logo */}
//                   {hasLogo && (
//                     <img
//                       src={form.logoUrl}
//                       alt="logo"
//                       style={{
//                         width: logoSize,
//                         height: logoSize,
//                         objectFit: "contain",
//                         marginLeft: `${gapQrLogo}px`,
//                         marginTop: `${logoMarginTop}px`,
//                         marginBottom: `${logoMarginBottom}px`,
//                       }}
//                     />
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PreviewQR;
